module.exports = __webpack_public_path__ + "officialStatic/img/wlCxBg.55da24b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/wlCxBg.jpg
// module id = dmiF
// module chunks = 0